import { render, staticRenderFns } from "./PasswordReissue.vue?vue&type=template&id=6de85839&"
import script from "./PasswordReissue.vue?vue&type=script&lang=ts&"
export * from "./PasswordReissue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports